export const sucursalRoutesMap = {
  gestion: {
    path: '/sucursal/gestion',
    name: 'Gestión de Sucursales',
  },
  nuevo: {
    path: '/sucursal/nuevo',
    name: 'Nuevo Registro',
  },
  modificar: {
    path: `/sucursal/modificar`,
    name: 'Actualizar Registro',
  },
}
